import humps from 'humps';
import { call } from 'redux-saga/effects';
import { itunesBaseUrl } from './utils';

interface FetchOptions {
  authRequired?: boolean;
}

interface Request {
  headers?: {
    [key: string]: string;
  };
  method?: string;
  body?: any;
}

type ApiOpts = FetchOptions & Request;

// Auth is required by default; to disable, use "opts.authRequired: false"
export default function* apiFetch(
  path: string,
  opts: ApiOpts = {},
  casing: string = 'camel',
): any {
  const defaultMethod = 'GET';
  const defaultHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  const options = {
    headers: defaultHeaders,
    method: defaultMethod,
    ...opts,
  };

  let authRequired =
    typeof opts.authRequired === 'undefined' || opts.authRequired;
  delete options.authRequired;

  let url;
  if (path.search(/https:\/\/|http:\/\//) === 0) {
    url = path;
  } else {
    authRequired = false;
    url = `${itunesBaseUrl}${path}`;
  }

  if (authRequired) {
    //const jwt = yield call(getApiSessionToken) //TODO: We will need to do it later!
    /*console.log(jwt)
    if (!jwt) {
      return {
        status: 401,
        body: {
          message: 'No auth token found on device.',
        },
      }
    }
    options.headers.Authorization = `Bearer ${jwt}`*/
  }

  if (options.body) {
    switch (casing) {
      case 'underscore':
        options.body = humps.decamelizeKeys(options.body);
        //options.body = options.body;
        break;
      case 'pascal':
        //options.body = humps.pascalizeKeys(options.body)
        // options.body = options.body
        break;
    }
    options.body = JSON.stringify(options.body);
  }

  try {
    const response: any = yield call(fetch, url, options);

    let body;
    const decodedBody = yield call([response, 'text']);
    if (options.headers.Accept === 'application/rss+xml') {
      //body = yield call([rssParser, 'parseString'], decodedBody)
    } else {
      body = decodedBody ? yield call([JSON, 'parse'], decodedBody) : {};
    }

    return {
      status: response.status,
      //body: humps.camelizeKeys(body),
      body: body,
    };
  } catch (err) {
    return {
      status: 400,
      body: { message: 'An unknown error occurred.' },
    };
  }
}
